import React from 'react';
import './About.css'; // Import the CSS file for styling

function About() {
  return (
    <div className="about-container">
      <h1 className="buzz">About Buzz Board</h1>
      <p>
        Buzz Board is your ultimate event companion—designed to revolutionize fundraising events, bingo nights, raffles, and pull tab games. Whether you're hosting a small community gathering or a large-scale event, Buzz Board ensures seamless coordination and engagement for both players and organizers.
      </p>
      <p>
        For players, Buzz Board provides real-time updates, allowing them to stay informed and engaged throughout the event. Winning numbers, game results, and announcements can be displayed on a shared screen for everyone to see or accessed individually by entering a game code on their own device. This eliminates confusion and ensures every participant feels connected to the action.
      </p>
      <p>
        For organizers, Buzz Board simplifies event management with intuitive tools that streamline game setup, tracking, and result sharing. Say goodbye to manual processes and hello to automated efficiency. With Buzz Board, you can focus on keeping the energy high and the excitement flowing, while the platform handles the logistics.
      </p>
      <p>
        Built by K&M Sales and inspired by our founder Buzz Mills, Buzz Board is more than just a tool—it's a modern solution tailored to enhance your events and leave a lasting impression. Our mission is to empower organizers with cutting-edge technology that’s easy to use, reliable, and designed to impress. Whether you're raising funds for a cause or hosting a fun-filled game night, Buzz Board is here to make your event unforgettable.
      </p>
    </div>
  );
}

export default About;